/**
 * Application Route Constants
 * Centralized route path definitions used throughout the application
 */

export const ROUTES = {
  // Home routes
  ROOT: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  MODERN_FEED: '/feed',
  MODERN_SUBSCRIPTIONS: '/subscriptions',
  MODERN_PURCHASED: '/purchased',

  // Discovery routes
  DISCOVER: '/discover',
  HOMESCREEN: '/homescreen',

  // Profile routes
  MY_PROFILE: '/my-profile',

  // Communication routes
  ACTIVITY: '/activity',

  // Settings routes
  EDIT_USERNAME: '/edit-username',
  CHANGE_PASSWORD: '/change-password',
  CREATOR_NOTIFICATIONS: '/my-notifications',
  NOTIFICATIONS: '/notifications',
  REFERRALS: '/referrals',
  EARNINGS_PAYOUT: '/earnings-payout',
  VAT_NUMBER: '/vat-number',
  GST_NUMBER: '/gst-number',
  BANK_ACCOUNT: '/bank-account',
  W9_TAX_INFO: '/w9-tax-info',
  W8_TAX_INFO: '/w8-tax-info',
  WALLET: '/wallet',
  TRANSACTIONS: '/transactions',
  PROFILE_TAGS: '/profile-tags',
  EARNINGS_REPORT: '/earnings-report',
  RESEND_VERIFICATION: '/resend-verification',

  WEBVIEW: '/webview',
  ALL_CREATORS: '/all-creators',
  ALL_CATEGORIES: '/all-categories',
  HELP: '/help',
  CREATOR_SIGNUP: '/creator-signup',
  SUBSCRIBER_SIGNUP: '/subscriber-signup',
  UNDER_REVIEW: '/under-review',
  FORGOT_PASSWORD: '/forgot-password',
  
  // Legal routes
  LEGAL_TERMS: '/termsofservice',
  LEGAL_PRIVACY: '/privacy',
  LEGAL_CCPA: '/ccpa',
  LEGAL_CREATOR_AGREEMENT: '/creator-agreement',
  LEGAL_COPYRIGHT: '/copyright',
  LEGAL_COMPLIANCE: '/compliance',
  LEGAL_REFERRAL: '/referral-terms',
  LEGAL_INFRINGER: '/infringer',

  // Support routes
  FAQ: '/faq',
  CONTACT_US: '/contactus',

  // Message routes (nned to change)
  MY_MESSAGES: '/my/messages',
  NEW_MESSAGE: '/new-message',
  NEW_CHAT_INTRO: '/my/messages/new',
};

